import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";

export interface showMobileFiltersParameter extends ApiParameter {
    showMobileFilters?: boolean;
}

export interface showMobileFiltersModel {
    showMobileFilters?: boolean;
}

type HandlerType = CustomApiHandler<showMobileFiltersParameter, showMobileFiltersModel>;

export const DispatchShowMobileFilters: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/ShowMobileFilters",
        result: props.parameter.showMobileFilters,
    });
};

export const chain = [DispatchShowMobileFilters];

const showMobileFilters = createHandlerChainRunnerOptionalParameter(chain, {}, "showMobileFilters");
export default showMobileFilters;
